// src/routes/doctorRoutes.js
import DoctorNav from "../../pages/Dashboard/Doctor/DoctorNav";
import DoctorIndex from "../../pages/Dashboard/Doctor/DoctorIndex";
import Patients from "../../pages/Dashboard/Doctor/Patients/Patients";
import AddTaskToNurse from "../../pages/Dashboard/Doctor/AddTaskToNurse/AddTaskToNurse";
import AddPrescription from "../../pages/Dashboard/Doctor/prescription/Prescription";
import PrescriptionList from "../../pages/Dashboard/Doctor/prescription/PrescriptionList";
import EditPrescription from "../../pages/Dashboard/Pharmacy/prescription/EditPrescription";

const doctorRoutes = {
  path: "/doctor",
  element: <DoctorNav />,
  children: [
    { path: "/doctor", element: <DoctorIndex /> },
    { path: "/doctor/patients", element: <Patients /> },
    { path: "/doctor/prescription", element: <PrescriptionList /> },
    { path: "/doctor/prescription/:id", element: <EditPrescription /> },
    { path: "/doctor/prescription/add", element: <AddPrescription /> },
    { path: "/doctor/add-task-to-nurse", element: <AddTaskToNurse /> },
  ],
};

export default doctorRoutes;
